<template>
    <jet-dialog-modal :show="show" @close="$emit('close')">
        <template #title>
            Pricing Bulk Edit
        </template>

        <template #content>
            <form @submit.prevent="handleSubmit">
                <div class="flex mb-2 gap-x-2 items-center" :class="{ 'opacity-50': !form.priceEnabled }">
                    <input type="checkbox" v-model="form.priceEnabled" />
                    <jet-label value="Price:" class="mb-0 w-14" />
                    <jet-input v-model.number="form.price" type="number" step="any" :disabled="!form.priceEnabled" class="price" />
                    <span v-show="!form.priceEnabled">No Changes</span>
                </div>

                <div
                    v-for="pricingLevel in form.pricing_levels"
                    :key="pricingLevel.id"
                    class="flex mb-2 gap-x-2 items-center"
                    :class="{ 'opacity-50': !pricingLevel.enabled }"
                >
                    <input v-model="pricingLevel.enabled" type="checkbox" />
                    <jet-label :value="pricingLevel.pricing_level_title" class="mb-0 w-14" />
                    <price-select
                        :pricing="pricingLevel"
                        @price-level-update="handlePriceLevelUpdate"
                        :disabled="!pricingLevel.enabled"
                    />
                    <span v-show="!pricingLevel.enabled">No Changes</span>
                </div>
                <div class="flex mb-2 gap-x-2 items-center" :class="{ 'opacity-50': !form.priceTwoPlusEnabled }">
                    <input type="checkbox" v-model="form.priceTwoPlusEnabled" />
                    <jet-label value="Retail price 2+:" class="mb-0 w-14" />

                    <div class="inline-flex justify-end">
                        <input v-model.number="form.price_2plus" type="number" step="any"
                        :disabled="!form.priceTwoPlusEnabled || type === '' || type === null || type === 'disabled'" class="rounded-l rounded-r-none" />

                        <select class="rounded-r rounded-l-none"
                        v-model="type"
                        @change="modifyPriceTwoPlus">
                            <option value="fixed">$</option>
                            <option value="disabled">X</option>
                        </select>
                    </div>

                    <span v-show="!form.priceTwoPlusEnabled">No Changes</span>
                </div>

                <input type="submit" class="hidden" ref="submit"/>
            </form>
        </template>

        <template #footer>
            <jet-button class="mr-2" :class="{ 'opacity-25': form.processing }" :disabled="form.processing" @click="$refs.submit.click()">
                Apply
            </jet-button>

            <jet-tertiary-button @click="$emit('close')">
                Cancel
            </jet-tertiary-button>
        </template>
    </jet-dialog-modal>
</template>

<script>
import JetButton from '@/Jetstream/Button';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetInput from '@/Jetstream/Input';
import JetLabel from '@/Jetstream/Label';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import PriceSelect from '@/Pages/Pricing/Partials/PriceSelect';

export default {
    emits: ['updated', 'close'],

    components: {
        JetDialogModal,
        JetButton,
        JetTertiaryButton,
        JetInput,
        JetLabel,
        PriceSelect,
    },

    props: ['show', 'pricingLevels'],

    data() {
        let formData = {
            price: null,
            priceEnabled: false,
            price_2plus: null,
            priceTwoPlusEnabled: false,
            pricing_levels: [],
        };

        this.pricingLevels.forEach(l => {
            formData.pricing_levels.push({
                enabled: false,
                pricing_level_title: l.title,
                pricing_level_id: l.id,
                price: null,
                modifier_type: null,
                modifier_amount: null,
            });
        });

        return {
            form: this.$inertia.form(formData),
            type: 'disabled',
        }
    },

    methods: {
        modifyPriceTwoPlus() {
            if (this.type === 'fixed') {
                return 'Fixed Price';
            } else if (this.type === 'disabled') {
                this.form.price_2plus = null;
                return "Disabled";
            }
        },

        handlePriceLevelUpdate (payload) {
            const pricingLevel = this.form.pricing_levels.find(p => p.pricing_level_id === payload.pricing_level_id);

            if (!pricingLevel) {
                return;
            }

            pricingLevel.price = payload.price;
            pricingLevel.modifier_type = payload.modifier_type;
            pricingLevel.modifier_amount = payload.modifier_amount;
        },

        handleSubmit () {
            this.$emit('close');
            this.$emit('updated', this.form.data());
            this.form.reset();
        }
    }
}
</script>

<style scoped>
    input[type="number"] {
        @apply py-1 px-1;
        max-width: 75px;
    }

    select:focus,
    input[type="number"]:focus {
        @apply z-10;
    }

    select {
        @apply text-sm pl-2 py-1 pr-8 border border-gray ring-green;
    }

    .price-select-sm input[type="number"],
    .price-select-sm select {
        @apply py-0;
    }
</style>
